module.exports = __webpack_public_path__ + "img/case1.8e2dba2a.png";